import { usePasswordFormValues } from 'hooks/usePasswordFormValues';

export const usePasswordFormEmpty = (): boolean => {
  const { password, passwordConfirm } = usePasswordFormValues();

  return !password && !passwordConfirm;
};
